import { cn } from "@omni/utils/styles";

import ContentBlockLink from "./contentListBlockLink/contentListBlockLink.component";

type Link = {
    url: string;
    name: string;
};

type Props = {
    content: {
        title: string;
        icon: string;
        links: [Link];
    };
};

const ContentBlock = ({ content }: Props) => {
    return (
        <div
            className={cn(
                "tw:min-h-20 tw:max-md:min-w-62.5",
                "tw:items-center",
                "tw:flex",
                "tw:flex-col",
                "tw:content-start",
                "tw:p-1",
                "tw:text-center"
            )}
        >
            {/** biome-ignore lint/a11y/useHeadingContent: <TODO> */}
            <h2 className={cn("tw:text-5xl tw:mb-2", content.icon)} />
            <h5 className={"tw:uppercase"}>{content.title}</h5>
            {content.links?.map((link: Link, index: number) => (
                <ContentBlockLink
                    key={index}
                    link={link}
                />
            ))}
        </div>
    );
};

export default ContentBlock;
